<template>
  <div class="inventory-buttons margin-top-2">
    <button
      @click="emitExport"
      class="button-gemnote-light button-gemnote--small"
    >
      <span> Export Inventory</span>
    </button>
    &nbsp;
    <button
      class="button-gemnote button-gemnote--small"
      :class="{
        'button-gemnote--disabled':
          isReplenishProducts || !productsToReplenish.length
      }"
      :disabled="isReplenishProducts || !productsToReplenish.length"
      @click="emitReplenish"
    >
      <span>Request restock</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'InventoryButtons',
  props: {
    isReplenishProducts: {
      type: Boolean,
      required: true
    },
    productsToReplenish: {
      type: Array,
      required: true
    }
  },
  methods: {
    emitExport() {
      this.$parent.handleExport()
    },
    emitReplenish() {
      this.$parent.replenishProducts()
    }
  }
}
</script>

<style lang="scss" scoped>
.inventory-buttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 15px;
  z-index: 10; /* Ensure buttons are above other elements */
}

.button-gemnote-light,
.button-gemnote {
  cursor: pointer;
  z-index: 10;
}

.button-gemnote-light {
  background: #f5f2ee;
  color: #24292c;
  padding: 0 1.25rem;
  height: 2.5rem;
  border-radius: 40px;
  text-transform: uppercase;
  font-family: 'Inter', sans-serif;

  &:hover {
    background: #f5f2ee;
    color: #24292c;
  }
}

.button-gemnote {
  background: #24292c;
  color: #f5f2ee;
  padding: 0 1.25rem;
  height: 2.5rem;
  border-radius: 40px;
  text-transform: uppercase;
  font-family: 'Inter', sans-serif;

  &:hover {
    background: #24292c;
    color: #f5f2ee;
  }
}

.button-gemnote--disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>
